<template>
  <component
    :is="currentComp"
    @success="loginSuccess"
    url="http://keystone.xtooltech.com/signin/login"
    domain="Xtooltech"
    project="x57NMjaKn93VYvQKXWDA"
    :menus="menus"
    :autoCollapse="false"
  ></component>
</template>

<script>
export default {
  name: 'main-content',

  data() {
    return {
      currentComp: 'Login',
    }
  },
  computed: {
    menus: {
      get() {
        return this.$store.state.menus
      },
      set(newVal) {
        this.$store.commit('setMenus', newVal)
      },
    },
  },
  created() {
    var token = this.$token
    if (token) this.loginSuccess(token)
  },
  methods: {
    loginSuccess(token) {
      this.currentComp = 'LeftMenu'
      this.$autoRefreshToken()
    },
  },
  watch: {
    $route: function (to, from) {
      //console.log(this.$route)
      //console.log(to.query.token)
      if (to.query.token) {
        var token = this.$checkToken()
        if (token) this.loginSuccess(token)
      }
    },
  },
}
</script>

<style>
</style>
